// The stickers above the chat box (PLAN-2026-10-30-stickers §5): every
// sticker drawn with the sender's own character, four across, a tap sending
// one at once and the tray staying open for another, as every chat app's do.
//
// A TEAM WITHOUT A FACE sees its badge held up on a placard, and the foot says
// how to make the stickers yours: a nudge to Edit team's face maker, never a
// gate, since the placard's stickers send.

import { STICKERS, type StickerId } from '@fsp/domain';
import type { KeyboardEvent } from 'react';
import { StickerArt, type StickerTeam } from '../kit/StickerArt';
import { IconButton } from '../kit/ui';

export function StickerTray({
  team,
  onPick,
  onClose,
  makeFace,
}: {
  /** Whose character the stickers are drawn with. */
  team: StickerTeam;
  onPick: (sticker: StickerId) => void;
  onClose: () => void;
  /** Opens Edit team, for a team whose badge is not a face; absent, no foot. */
  makeFace?: () => void;
}) {
  const keys = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== 'Escape') return;
    e.stopPropagation();
    onClose();
  };
  return (
    <div className="fsp-stickers" role="dialog" aria-label="Stickers" onKeyDown={keys}>
      <div className="fsp-stickers-head">
        <span className="fsp-stickers-title">Stickers</span>
        <IconButton icon="close" label="Close stickers" variant="quiet" onClick={onClose} />
      </div>
      <div className="fsp-stickers-grid" role="group" aria-label="Send a sticker">
        {STICKERS.map((s) => (
          <button
            key={s.id}
            type="button"
            className="fsp-stickers-cell"
            aria-label={`Send ${s.words}`}
            onClick={() => onPick(s.id)}
          >
            <StickerArt sticker={s.id} words={s.words} team={team} height={66} still />
          </button>
        ))}
      </div>
      {makeFace ? (
        <p className="fsp-stickers-foot">
          Make your team a face and these are you.{' '}
          <button type="button" className="fsp-linklike" onClick={makeFace}>
            Make a face
          </button>
        </p>
      ) : null}
    </div>
  );
}
